// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"6a5730e0","16":"014adcac","56":"e96721bb","58":"2ce22f81","172":"6a13a92d","182":"759751c3","340":"700b6152","552":"50ed6eb2","913":"05ee117e","940":"b9b7354f","975":"52688cf9"}[chunkId] + ".chunk.js";
};